import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=3380d9d7&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports